var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "premDiv" }, [
    this.$store.state.sceneElementCurrentPopup != -1
      ? _c("div", { attrs: { id: "modalContainer" } }, [
          _c(
            "button",
            {
              attrs: { id: "closePopup" },
              on: {
                click: function($event) {
                  return _vm.activePopup(-1)
                }
              }
            },
            [_vm._v("×")]
          ),
          _vm._v(" "),
          _c("div", { attrs: { id: "customModal" } }, [
            _c("div", { attrs: { id: "selectorContainer" } }, [
              _c(
                "button",
                {
                  class:
                    this.$store.state.sceneElementCurrentPopup == 0
                      ? "active"
                      : "",
                  on: {
                    click: function($event) {
                      return _vm.activePopup(0)
                    }
                  }
                },
                [_vm._v("Characters")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  class:
                    this.$store.state.sceneElementCurrentPopup == 1
                      ? "active"
                      : "",
                  on: {
                    click: function($event) {
                      return _vm.activePopup(1)
                    }
                  }
                },
                [_vm._v("Models")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  class:
                    this.$store.state.sceneElementCurrentPopup == 5
                      ? "active"
                      : "",
                  on: {
                    click: function($event) {
                      return _vm.activePopup(5)
                    }
                  }
                },
                [_vm._v("Effects")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  class:
                    this.$store.state.sceneElementCurrentPopup == 6
                      ? "active"
                      : "",
                  on: {
                    click: function($event) {
                      return _vm.activePopup(6)
                    }
                  }
                },
                [_vm._v("Lights")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  class:
                    this.$store.state.sceneElementCurrentPopup == 2
                      ? "active"
                      : "",
                  on: {
                    click: function($event) {
                      return _vm.activePopup(2)
                    }
                  }
                },
                [_vm._v("Sounds")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  class:
                    this.$store.state.sceneElementCurrentPopup == 3
                      ? "active"
                      : "",
                  on: {
                    click: function($event) {
                      return _vm.activePopup(3)
                    }
                  }
                },
                [_vm._v("Videos")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  class:
                    this.$store.state.sceneElementCurrentPopup == 4
                      ? "active"
                      : "",
                  on: {
                    click: function($event) {
                      return _vm.activePopup(4)
                    }
                  }
                },
                [_vm._v("Images")]
              )
            ]),
            _vm._v(" "),
            this.$store.state.sceneElementCurrentPopup == 1
              ? _c(
                  "div",
                  [
                    _c("models", {
                      on: {
                        closePopup: function($event) {
                          return _vm.activePopup(-1)
                        }
                      }
                    })
                  ],
                  1
                )
              : this.$store.state.sceneElementCurrentPopup == 0
              ? _c(
                  "div",
                  [
                    _c("character", {
                      on: {
                        closePopup: function($event) {
                          return _vm.activePopup(-1)
                        }
                      }
                    })
                  ],
                  1
                )
              : this.$store.state.sceneElementCurrentPopup == 2
              ? _c(
                  "div",
                  [
                    _c("sounds", {
                      on: {
                        closePopup: function($event) {
                          return _vm.activePopup(-1)
                        }
                      }
                    })
                  ],
                  1
                )
              : this.$store.state.sceneElementCurrentPopup == 3
              ? _c(
                  "div",
                  [
                    _c("Video", {
                      on: {
                        closePopup: function($event) {
                          return _vm.activePopup(-1)
                        }
                      }
                    })
                  ],
                  1
                )
              : this.$store.state.sceneElementCurrentPopup == 4
              ? _c(
                  "div",
                  [
                    _c("mediaImages", {
                      on: {
                        closePopup: function($event) {
                          return _vm.activePopup(-1)
                        }
                      }
                    })
                  ],
                  1
                )
              : this.$store.state.sceneElementCurrentPopup == 5
              ? _c(
                  "div",
                  [
                    _c("effect", {
                      on: {
                        closePopup: function($event) {
                          return _vm.activePopup(-1)
                        }
                      }
                    })
                  ],
                  1
                )
              : this.$store.state.sceneElementCurrentPopup == 6
              ? _c(
                  "div",
                  [
                    _c("light", {
                      on: {
                        closePopup: function($event) {
                          return _vm.activePopup(-1)
                        }
                      }
                    })
                  ],
                  1
                )
              : _c("div")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    this.$store.state.sceneElementCurrentPopup != -1
      ? _c("div", { attrs: { id: "mask" } })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card-header pl-0" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("div", { staticClass: "dropdown mr-3" }, [
            _c(
              "ul",
              {
                staticClass: "dropdown-menu",
                attrs: { "aria-labelledby": "dropdownMenuButton" }
              },
              [
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.showComponent("modelsinspector", 1)
                        }
                      }
                    },
                    [_vm._v("3D Model")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.showComponent("characterinspector", 2)
                        }
                      }
                    },
                    [_vm._v("Character Model")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.showComponent("lightsinspector", 0)
                        }
                      }
                    },
                    [_vm._v("Lights")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    { staticClass: "dropdown-item", attrs: { href: "#" } },
                    [_vm._v(" Media ")]
                  ),
                  _vm._v(" "),
                  _c("ul", { staticClass: "dropdown-menu dropdown-submenu" }, [
                    _c("li", [
                      _c(
                        "span",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function($event) {
                              return _vm.showComponent("soundinspector")
                            }
                          }
                        },
                        [_vm._v("Sound")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "span",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function($event) {
                              return _vm.showComponent("videosinspector")
                            }
                          }
                        },
                        [_vm._v("Videos")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "span",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function($event) {
                              return _vm.showComponent("imagesinspector")
                            }
                          }
                        },
                        [_vm._v("Images")]
                      )
                    ])
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body p-2" }, [
      _c("div", { staticClass: "timeline-wrapper" }, [
        _c("div", { attrs: { id: "timeline-div" } }, [_c("newTimeLine")], 1)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "fas fa-stopwatch" }),
      _vm._v("\n      Timeline")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48686693", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48686693","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/timeline.vue
// module id = null
// module chunks = 